import React from 'react';

const SvgBusinessStats: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 12v8M14.7 14.67V20M4 17v3M9.3 13.6V20M15.94 8.509a1.75 1.75 0 11-2.475 2.474 1.75 1.75 0 012.474-2.474M21.342 4.006a1.75 1.75 0 11-2.474 2.474 1.75 1.75 0 012.474-2.474M5.132 9.403a1.75 1.75 0 11-2.474 2.474 1.75 1.75 0 012.474-2.474M10.536 4.9a1.75 1.75 0 11-2.474 2.475 1.75 1.75 0 012.474-2.474M18.77 6.36l-2.73 2.27M13.24 8.78l-2.49-1.67M5.24 9.53l2.72-2.27" />
      </g>
    </svg>
  );
};

export default SvgBusinessStats;
